import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoEksen } from '../FikoEksen';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor3D } from '../FikoVektor3d';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';
import { FikoTakimYolu } from './FikoTakimYolu';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';

export class FikoAPTCAT extends FikoGrup {
    override type: any = "FikoAPTCAT";
    /** */
    sagButonlar: any[] = [
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                import('../fiko-similasyon-v1/fiko-similasyon-v1.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim ?? (this as any).parent?.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) { console.warn('DialogFiko bulunamadi'); return; }
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSimilasyonV1Component,
                        parametreler: { anaNesne: this },
                        ayarlar: { baslik: 'Similasyon', simgeResim: './simgeler/takimyolu.webp' }
                    });
                });
            }
        },
        {
            isim: "Sıvı Simülasyonu",
            simge: "experiment",
            tiklandi: () => {
                import('../fiko-sph-sivi/components/fiko-sph-sivi.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim ?? (this as any).parent?.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) { console.warn('DialogFiko bulunamadi'); return; }
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSPHSiviComponent,
                        id: 'fiko-sph-sivi-dialog',
                        parametreler: { anaNesne: this, anaGosterim: gosterim },
                        ayarlar: {
                            baslik: 'SPH Sıvı Simülasyonu',
                            modalMi: false,
                            boyut: { w: 1200, h: 800 }
                        }
                    });
                });
            }
        }
    ]
    /** */
    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoApt.ac(this as any);
            }
        },
        {
            simge: null,
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    aracCubugu: any[] = [
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {

            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);
                this.sahne.anaGosterim.aktifItem = null;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    public get tarihi(): Date {
        return this.userData['tarihi'];
    }
    public set tarihi(v: Date) {
        this.userData['tarihi'] = v;
    }

    public get programIsmi(): string {
        return this.userData['programIsmi'];
    }
    public set programIsmi(v: string) {
        this.userData['programIsmi'] = v;
    }

    public get kureMerkezi(): boolean {
        return this.userData['kureMerkezi'];
    }
    public set kureMerkezi(v: boolean) {
        this.userData['kureMerkezi'] = v;
    }

    public get operasyonIsmi(): string {
        return this.userData['operasyonIsmi'];
    }
    public set operasyonIsmi(v: string) {
        this.userData['operasyonIsmi'] = v;
    }

    public get eksenKoord(): { x?: FikoVektor3D, y?: FikoVektor3D, z?: FikoVektor3D, o?: FikoVektor3D } {
        return this.userData['eksenKoord'];
    }
    public set eksenKoord(v: { x?: FikoVektor3D, y?: FikoVektor3D, z?: FikoVektor3D, o?: FikoVektor3D }) {
        this.userData['eksenKoord'] = v;
    }

    aktiviteler?: { ismi: string, alt: any[], koordinatlar?: FikoVektorTakimYol3D[], takim?: FikoTakim, takimYonu?: number[], toplamSure?: number }[]

    eksen: FikoEksen;

    takimYolu: FikoTakimYolu = new FikoTakimYolu();

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/apt.webp";
    }



    ciftTiklandi() {
        // this.sahne.anaGosterim.DialogFikoApt.ac(this);
    }

    sagTiklandi() {
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        this.takimYolu.jsonParcala();
        const _rslt: any = {
            type: this.type,
            isim: this.name,

            tarihi: this.tarihi,
            programIsmi: this.programIsmi,
            kureMerkezi: this.kureMerkezi,
            operasyonIsmi: this.operasyonIsmi,
            eksenKoord: {
                x: this.eksenKoord.x.toArray(),
                y: this.eksenKoord.y.toArray(),
                z: this.eksenKoord.z.toArray(),
                o: this.eksenKoord.o.toArray()
            },
            takimYolu: this.takimYolu.toJSON()
        };

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoAPTCAT(sahne, json.isim);

        _rslt.parent = parent;

        _rslt.tarihi = json.tarihi;
        _rslt.programIsmi = json.programIsmi;
        _rslt.kureMerkezi = json.kureMerkezi;
        _rslt.operasyonIsmi = json.operasyonIsmi;
        _rslt.eksenKoord = {
            x: new FikoVektor3D().fromArray(json.eksenKoord.x),
            y: new FikoVektor3D().fromArray(json.eksenKoord.y),
            z: new FikoVektor3D().fromArray(json.eksenKoord.z),
            o: new FikoVektor3D().fromArray(json.eksenKoord.o)
        };

        _rslt.takimYolu = jsondan(sahne, parent, json.takimYolu);

        _rslt.ekle(_rslt.takimYolu);

        return _rslt;
    }
}